// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { TaskOutput } from 'thehive-sdk';
import RouteBuilder from '@Services/RouteBuilder';
import { ResultCard } from '@Organisms/Search/SearchResultCard/ResultCard';
import { extractData } from './extractData';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

import './TaskResultCard.scss';

interface TaskResultCardProps {
    data?: TaskOutput;
}

export const TaskResultCard = ({ data }: TaskResultCardProps): ReactElement => {
    const i = useLocalMessage();

    const {
        title = '',
        _createdAt = 0,
        status = '',
        description = '',
        _id = '',
        assignee = '',
        endDate = 0,
        startDate = 0,
        extraData,
    } = data || {};

    const { _id: caseId } = extraData?.case || {};

    return (
        <ResultCard
            data={{
                '#computeTitle': {
                    title,
                    path: RouteBuilder.compute('cases.task', { caseId, taskId: _id }),
                    icon: <ICONS.TaskIcon />,
                },
                '#computeDate': {
                    date: _createdAt,
                    assignee,
                },
                '#computeStatus': {
                    status,
                    startDate,
                    endDate,
                    _createdAt,
                },
                '#computeDescription': description,
            }}
            extract={extractData({ locale: i })}
        />
    );
};
